 <template>
  <table class="table is-fullwidth">
    <tr>
      <td class="key is-narrow">Customer</td>
      <td>
        <i
          class="fa fa-phone is-pulled-right"
          @click="showCustomerPhone = !showCustomerPhone"
        />
        <p class="single-line">{{ customer }}</p>
        <p v-if="showCustomerPhone">
          <span class="link" @click="callPhoneNumber(t.customer.phone_number)">
            {{ t.customer.phone_number }}
          </span>
        </p>
      </td>
    </tr>
    <tr>
      <td class="key">Pickup</td>
      <td>
        {{ d.pickup_stop.name || "Pin Location" }}
        <i
          class="fa fa-map-marker-alt is-pulled-right"
          @click="showPickupCoords = !showPickupCoords"
        />
        <p v-if="showPickupCoords">
          <span class="link" @click="openMap(d.pickup_stop)">
            {{ `${d.pickup_stop.lat}, ${d.pickup_stop.lon}` }}
          </span>
        </p>
      </td>
    </tr>
    <tr>
      <td class="key">Dropoff</td>
      <td>
        {{ d.dropoff_stop.name || "Pin Location" }}
        <i
          class="fa fa-map-marker-alt is-pulled-right"
          @click="showDropoffCoords = !showDropoffCoords"
        />
        <p v-if="showDropoffCoords">
          <span class="link" @click="openMap(d.dropoff_stop)">
            {{ `${d.dropoff_stop.lat}, ${d.dropoff_stop.lon}` }}
          </span>
        </p>
      </td>
    </tr>
    <tr>
      <td class="key">Fare</td>
      <td>
        {{ `฿${d.fare.price} (${d.fare.cash} cash)` }}
        <span class="is-pulled-right" @click="openRoute">
          {{ d.fare.distance }}m
          <i class="fa fa-route" />
        </span>
      </td>
    </tr>
    <tr>
      <td class="key">Order</td>
      <td>
        {{ `฿${d.delivery.order_value} ${paymentMethod}` }}
        <span class="tag is-pulled-right">
          Collect ฿{{ d.delivery.order_value + d.fare.cash }}
        </span>
      </td>
    </tr>
    <tr v-if="d.delivery.cashback">
      <td class="key has-text-warning">Cashback</td>
      <td class="has-text-warning">
        {{ `฿${d.delivery.cashback}` }}
      </td>
    </tr>
    <tr>
      <td class="key">Created</td>
      <td>
        {{ new Date(t.created_at).toLocaleTimeString("en-GB") }}
        <span class="tag is-pulled-right">
          Updated {{ timeAgo(t.updated_at) }}
        </span>
      </td>
    </tr>
    <tr @click="showFleetOptions = !showFleetOptions">
      <td class="key">Fleet</td>
      <td>
        <span>{{ expressFleet }}</span>
        <span v-if="fallbackFleet" class="tag is-pulled-right">
          {{ shortenString(fallbackFleet, 15) }}
        </span>
      </td>
    </tr>
    <tr v-if="showFleetOptions">
      <td colspan="2">
        <span class="key">Fleet Options</span>&nbsp;
        <span v-if="t.state === 'initiated'" class="tag is-info" @click="addTip"
          >Add Tip
          <span v-if="lalamoveTip" style="margin-left: 4px"
            >({{ lalamoveTip }})</span
          > </span
        >&nbsp;
        <span class="tag is-primary" @click="cancelAndRetry"
          >Cancel and Retry</span
        >&nbsp;
        <span class="tag is-warning" @click="cancelDelivery">Cancel</span>&nbsp;
        <span class="tag is-white" @click="changeFleet">Change Fleet</span>
        <!-- <p v-if="lalamoveTip">
          <span class="tag">Current Tip: {{ lalamoveTip }} </span>
        </p> -->
      </td>
    </tr>

    <tr v-if="lalamoveShareLink">
      <td class="key">Lalamove</td>
      <td>
        <span class="link" @click="openLalamoveShareLink">
          Share Link&nbsp;<i class="fa fa-mobile-alt" />
        </span>
        <span class="link is-pulled-right" @click="openLalamoveDashboard">
          Dashboard&nbsp;<i class="fa fa-desktop" />
        </span>
        <!-- <i class="fa fa-external-link-alt is-pulled-right" /> -->
      </td>
    </tr>

    <tr @click="showEvents">
      <td class="key">Events</td>
      <td>
        {{ toConfirmed }} - {{ toArrived }} - {{ toEnroute }} - {{ toAlighted }}
        <!-- to_confirmed, to_arrived, to_enroute, to_alighted -->
      </td>
    </tr>

    <tr>
      <td class="key">Driver</td>
      <td>
        <div v-if="t.driver">
          <i
            class="fa fa-phone is-pulled-right"
            @click="showDriverPhone = !showDriverPhone"
          />
          <p class="single-line">
            <span class="link" @click="toggleDriverList">{{
              t.driver.name
            }}</span>
          </p>

          <p v-if="showDriverPhone">
            <span class="link" @click="callPhoneNumber(t.driver.phone_number)">
              {{ t.driver.phone_number }}
            </span>
          </p>
        </div>
        <div v-else>
          <i class="link" @click="toggleDriverList"> Assign driver </i>
          <span class="tag is-pulled-right is-danger">No driver yet</span>
        </div>

        <!-- <div v-if="showDriverList" class="driver-list">
          <div style="height: 8px" />
          <p v-if="!drivers.length" style="opacity: 0.6">
            <i class="fa fa-spinner fa-spin" />&nbsp;Fetching drivers
          </p>
          <p
            v-for="d in drivers"
            :key="d.key"
            @click="changeDriver(d.value)"
            class="single-line no-scrollbar"
            style="max-width: calc(100vw - 145px)"
          >
            {{ d.key }}
          </p>
        </div> -->
      </td>
    </tr>
    <tr v-if="showDriverList" class="driver-list" style="width: 0">
      <td colspan="2">
        <p v-if="!drivers.length" style="opacity: 0.6">
          <i class="fa fa-spinner fa-spin" />&nbsp;Fetching drivers
        </p>
        <p
          v-for="d in drivers"
          :key="d.key"
          @click="preChangeDriver(d)"
          class="single-line no-scrollbar"
          style="max-width: calc(100vw - 36px)"
        >
          {{ d.key }}
        </p>
        <div v-if="fallbackWorkflowID">
          <p v-if="!fallbackDrivers.length" style="opacity: 0.6">
            <i class="fa fa-spinner fa-spin" />&nbsp;Fetching fallback drivers
          </p>
          <p
            v-for="d in fallbackDrivers"
            :key="d.key + 'f'"
            @click="preChangeDriver(d)"
            class="single-line no-scrollbar"
            style="max-width: calc(100vw - 36px); background-color: #aaa"
          >
            {{ d.key }}
          </p>
        </div>
      </td>
    </tr>
  </table>
</template>


<script>
// import DeliveryDetailsTable from "@/components/DeliveryDetailsTable.vue";

export default {
  name: "CommerceDetailsTable",
  //   components: {},
  props: {
    t: Object, // transaction
  },
  data() {
    return {
      showCustomerPhone: false,
      showDriverPhone: false,
      showPickupCoords: false,
      showDropoffCoords: false,
      showDriverList: false,
      drivers: [],
      fallbackDrivers: [],
      showFleetOptions: false,
    };
  },
  computed: {
    d() {
      return this.t.data;
    },
    lalamoveTip() {
      return this.d.lalamove_tip_amount;
    },
    lalamoveShareLink() {
      return this.d.lalamove_share_link;
    },
    customer() {
      return this.t.customer.name || "Unknown " + this.t.customer.phone_number;
    },
    paymentMethod() {
      var pm = this.d.delivery.payment_method;
      return this.translatePayment(pm).toUpperCase();
    },
    expressFleet() {
      return (
        this.t.data.delivery.express_fleet || this.lastFive(this.t.workflow_id)
      );
    },
    fallbackFleet() {
      return this.t.data.delivery.fallback_fleet;
    },
    fallbackWorkflowID() {
      return this.t.data.fallback_workflow_id;
    },
    toConfirmed() {
      var a = this.d.event_created || this.t.created_at;
      var b = this.d.event_confirmed;
      return this.timeDifferenceMinutes(a, b);
    },
    toArrived() {
      var a = this.d.event_confirmed;
      var b = this.d.event_driver_arrived;
      return this.timeDifferenceMinutes(a, b);
    },
    toEnroute() {
      var a = this.d.event_driver_arrived;
      var b = this.d.event_enroute;
      return this.timeDifferenceMinutes(a, b);
    },
    toAlighted() {
      var a = this.d.event_enroute;
      var b = this.d.event_alighted;
      return this.timeDifferenceMinutes(a, b);
    },
  },
  methods: {
    // gotoBusinessProfile() {
    //   this.goto("/business_profile/" + this.t.workflow_id);
    // },
    changeFleet() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='fa fa-motorcycle'></i>&nbsp;Change Express Fleet</p>
        <p>Enter the exact name of the fleet or choose from the options in the error response.</p>
        </div>`,
        showCloseButton: true,
        input: "text",
      });
    },
    addTip() {
      var currentTip = "";
      if (this.lalamoveTip)
        currentTip = `<br><p><i>Current tip: ${this.lalamoveTip}</i></p>`;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'><i class='fa fa-coins'></i>&nbsp;Add a tip<p/>
        <p>For now only works for lalamove tips, but we could add to tukpay as well.</p>
        ${currentTip}
        </div>`,
        input: "text",
        inputPlaceholder: "฿10",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Add Tip",
        inputValidator: (val) => {
          if (!val || parseInt(val) < this.lalamoveTip)
            return "Must be greater than " + this.lalamoveTip;
        },
      }).then((val) => {
        if (val.value) {
          var intTip = parseInt(val.value);
          this.infoToast("Adding Tip ฿" + intTip);
          var data = {
            id: this.t.id,
            tip: intTip,
          };
          var loader = this.loadingDots("orange");
          this.$store
            .dispatch("addTipToDelivery", data)
            .then(() => this.successToast("Success!"))
            .catch((err) => this.apiError(err))
            .finally(() => loader.hide());
        }
      });
    },
    cancelDelivery() {
      var data = {
        transaction_id: this.t.id,
        lalamove_order_id: this.t.data.lalamove_order_id,
      };
      var loader = this.loadingDots();
      this.$store
        .dispatch("cancelLalamoveOrder", data)
        .then(() => this.successToast("Success"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    cancelAndRetry() {
      var data = {
        transaction_id: this.t.id,
        lalamove_order_id: this.t.data.lalamove_order_id,
      };
      var loader = this.loadingDots();
      this.$store
        .dispatch("retryLalamoveOrder", data)
        .then(() => this.successToast("Success"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    openLalamoveShareLink() {
      window.open(this.lalamoveShareLink, "_target");
    },
    openLalamoveDashboard() {
      var url = `https://web.lalamove.com/orders?max=10&start=2021-05-10&end=2021-07-09`;
      window.open(url, "_target");
    },
    showEvents() {
      var createdAt = new Date(this.t.created_at).toLocaleTimeString("en-GB");
      var startedAt = this.t.data.event_created; // actual createdAt of original delivery
      if (startedAt) {
        createdAt = new Date(startedAt).toLocaleTimeString("en-GB");
      }
      var alightedAt = this.t.data.event_alighted;
      var updatedAt = new Date(this.t.updated_at).toLocaleTimeString("en-GB");
      if (alightedAt) {
        updatedAt = new Date(alightedAt).toLocaleTimeString("en-GB");
      }
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:10px'>Delivery Events</p>
        <p style='margin-bottom:4px'>Created <button style='float:right'>${createdAt}</button></p>
        <p style='margin-bottom:4px'>Created - Confirmed
        <span style='float:right'>${this.toConfirmed} mins</span>
        </p>
        <p style='margin-bottom:4px'>Confirmed - Arrived
        <span style='float:right'>${this.toArrived} mins</span>
        </p>
        <p style='margin-bottom:4px'>Arrived - Enroute
        <span style='float:right'>${this.toEnroute} mins</span>
        </p>
        <p style='margin-bottom:4px'>Enroute - Alighted
        <span style='float:right'>${this.toAlighted} mins</span>
        </p>
        <p style='margin-bottom:4px'>Updated <button style='float:right'>${updatedAt}</button></p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    timeDifferenceMinutes(a, b) {
      if (!a || !b) return "⏱";
      return Math.round((new Date(b) - new Date(a)) / (1000 * 60));
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    toggleDriverList() {
      this.showDriverList = !this.showDriverList;
      if (!this.showDriverList) return;
      // update driver list
      this.drivers = [];
      console.log("autocompleteDeliveryDrivers", this.t.workflow_id);
      this.$store
        .dispatch("autocompleteDeliveryDrivers", this.t.workflow_id)
        .then((data) => {
          if (data) this.drivers = data;
          else this.drivers = [];
        })
        .catch((err) => this.apiError(err));
      if (this.fallbackWorkflowID) this.getFallbackDeliveryDrivers();
    },
    getFallbackDeliveryDrivers() {
      this.fallbackDrivers = [];
      this.$store
        .dispatch("autocompleteDeliveryDrivers", this.fallbackWorkflowID)
        .then((data) => {
          if (data) this.fallbackDrivers = data;
          else this.fallbackDrivers = [];
        })
        .catch((err) => this.apiError(err));
    },
    preChangeDriver(d) {
      this.$swal({
        html: `<div style='text-align:left'>
<p style='font-weight:500; font-size:1.2em; opacity:0.7; margin-bottom:10px'>Change driver to:</p>
<p>${d.key}</p>
</div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Yes, Change",
        confirmButtonColor: this.bulmaColor("primary"),
      }).then((val) => {
        if (val.value) this.changeDriver(d.value);
      });
    },
    changeDriver(driverID) {
      console.log("changeDriver", driverID);
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: {
            // state: "confirmed",
            handled_by: driverID,
            data: { acknowledged: false },
          },
        })
        .then(() => this.successToast("Changed driver, reload to check", "top"))
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.showDriverList = false;
        });
    },
    openMap(coords) {
      var url = `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
      window.open(url, "_blank");
    },
    openRoute() {
      var scoords = `${this.d.pickup_stop.lat},${this.d.pickup_stop.lon}`;
      var dcoords = `${this.d.dropoff_stop.lat},${this.d.dropoff_stop.lon}`;
      var url = `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`;
      window.open(url, "_blank");
    },
    // coords info
    showMoreInfo(key) {
      var data = this.t.data;
      if (key === "Fare") {
        if (data.pickup_stop && data.dropoff_stop) {
          this.mapURL = this.directionsURL(data.pickup_stop, data.dropoff_stop);
        } else if (data.address && data.business) {
          this.mapURL = this.directionsURL(data.business, data.address);
        } else return;
        this.moreInfo = "View driving route";
        return;
      }
      // just show coords and link to google location
      var p = null;
      if (key === "Pickup") {
        p = data.pickup_stop;
        this.moreInfo = `Pickup: ${p.lat}, ${p.lon}`;
      }
      if (key === "Dropoff") {
        p = data.dropoff_stop;
        this.moreInfo = `Dropoff: ${p.lat}, ${p.lon}`;
      }
      if (key === "Shop") {
        p = data.business;
        this.moreInfo = `Shop: ${p.lat}, ${p.lon}`;
      }
      if (key === "Address") {
        p = data.address;
        this.moreInfo = `Address: ${p.lat}, ${p.lon}`;
      }
      if (p) this.mapURL = this.googleMapURL(p);
    },
    directionsURL(s, d) {
      var scoords = `${s.lat},${s.lon}`;
      var dcoords = `${d.lat},${d.lon}`;
      return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`;
    },
    googleMapURL(coords) {
      return `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
    },
    gotoMapURL() {
      window.open(this.mapURL, "_blank");
    },
    callPhone(e) {
      var val = e.target.innerText;
      if (val === "Customer") {
        this.calling = "Customer: " + this.t.customer.phone_number;
        this.callPhoneNumber(this.t.customer.phone_number);
      }
      if (val === "Driver") {
        this.calling = "Driver: " + this.t.driver.phone_number;
        this.callPhoneNumber(this.t.driver.phone_number);
      }
      if (val === "Shop") {
        this.goto(`/shop/${this.t.business_id}?tab=info`);
        this.calling = "from shop profile...";
      }
    },

    // parseDelivery() {
    //   var t = this.t;
    //   var total = t.data.delivery.order_value + t.data.fare.cash; // t.data.fare.price;
    //   var pm = t.data.delivery.payment_method;
    //   var paymentMethod = this.translatePayment(pm).toUpperCase();
    //   var o = {
    //     Customer: t.customer.name || "Unknown " + t.customer.phone_number,
    //     Pickup: t.data.pickup_stop.name || "Pin Location",
    //     Dropoff: t.data.dropoff_stop.name || "Pin Location",
    //     Fare: `฿${t.data.fare.price} (${t.data.fare.cash} cash) ${t.data.fare.distance}m`,
    //     Order: `฿${t.data.delivery.order_value} ${paymentMethod}`,
    //     Collect: `<strong>฿${total}</strong>`,
    //     Created: new Date(t.created_at).toLocaleTimeString("en-GB"),
    //     Updated: this.timeAgo(t.updated_at),
    //     Driver: "No Driver Yet",
    //   };
    //   if (t.data.delivery.is_free_delivery) o.Order += " (Free Delivery)";
    //   if (t.driver) {
    //     o.Driver = `<span class='link' @click='changeDriver(t)'>${t.driver.name}</span>`;
    //   }
    //   o.Customer += ` <i class='fa fa-phone is-pulled-right' />`;
    //   o.Driver += ` <i class='fa fa-phone is-pulled-right' />`;
    //   return o;
    // },
  },
};
</script>

<style scoped>
.table-wrapper {
  overflow: scroll;
  max-height: calc(100vh - 85px);
}
.table {
  margin-bottom: 10px;
  background-color: #333;
  color: snow;
}
.table td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}
.calling {
  /* color: yellow; */
  margin-bottom: 10px;
  background-color: #ffdd57;
  padding: 4px;
}
.key {
  font-weight: 550;
  /* color: rgba(84, 84, 84, 0.671); */
  color: rgba(255, 250, 250, 0.3);
  padding-right: 0;
  /* overflow-wrap: none; */
  white-space: nowrap;
}
td {
  /* max-width: calc(100); */
  overflow-wrap: anywhere;
  padding: 8px 10px;
}
.action-btns {
  margin-bottom: 0;
  position: sticky;
  bottom: 0px;
  backdrop-filter: blur(2px);
}
.action-btns .button {
  padding: 9px;
}
.tag {
  padding: 4px;
}
.fa-external-link-alt {
  padding: 4px;
}
/* .link {
  border-bottom: 1px #ccc dotted;
} */
.fa {
  padding: 4px;
}
.driver-list td {
  padding: 0;
}
.driver-list p {
  background-color: #666;
  margin: 2px;
  padding: 4px 6px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  max-width: calc(100vw - 170px);
  text-overflow: ellipsis;
}
</style>
